<template>
  <div class="b-login">
    <q-form ref="form" @reset="reset" @submit="login">
      <i-field ref="username" v-model="userId" field-type="dic" dic="user" prepend-icon="account_circle" label="登录名" :rules="[rules.notWhitespace]"
        @keydown.enter.prevent="onFieldEnter($refs.username, $refs.password)" :disable="!usersLoaded" :loading="usersLoading"/>
      <i-field ref="password" v-model="model.password" prepend-icon="vpn_key" type="password" required label="密码" :rules="[rules.notWhitespace]"
        @keydown.enter.prevent="onFieldEnter($refs.password, login)" />
      <div class="b-login-actions">
        <q-btn type="reset" size="md" :disable="logining" flat rounded color="primary" icon="undo" label="重置" />
        <q-btn type="submit" size="md" :loading="logining" :disable="logining" rounded color="primary" icon="login" label="登录" />
      </div>
    </q-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import rules from '@/lib/rules'
import utils from '@/lib/utils'
const { mapState: mapAuthorizeState, mapGetters: mapAuthorizeGetters, mapMutations: mapAuthorizeMutations } = createNamespacedHelpers('bis/authorize')
const { mapGetters: mapDicGetters, mapActions: mapDicActions } = createNamespacedHelpers('bis/dic')

export default {
  data () {
    return {
      rules,
      selectedUserId: null,
      model: {
        username: null,
        password: null
      },
      logining: false,
      loadUsersWorker: null,
      usersLoading: false,
      loadTerminalsWorker: null,
      terminalsLoading: false
    }
  },
  computed: {
    ...mapAuthorizeState({
      storedUsername: state => state.user?.username
    }),
    ...mapAuthorizeGetters(['authorized']),
    ...mapDicGetters(['userById', 'usersLoaded']),
    initialModel () {
      return {
        username: this.$route.query['app.login.username'] ?? this.storedUsername,
        password: this.$route.query['app.login.password'] ?? null
      }
    },
    userId: {
      get () {
        return this.selectedUserId ?? this.users?.find(user => user.username === this.model.username)?.id
      },
      set (val) {
        this.selectedUserId = val
        this.model.username = this.userById && this.userById(this.selectedUserId)?.username
      }
    },
    auto () {
      return Boolean(this.$route.query['app.login.auto'])
    }
  },
  async mounted () {
    this.loadUsersWorker = new utils.RetryWorker(async () => {
      this.usersLoading = true
      await this.loadUsers()
      this.usersLoading = false
    }, () => {
      return this.usersLoaded
    })
    // this.loadTerminalsWorker = new utils.RetryWorker(async () => {
    //   this.terminalsLoading = true
    //   await this.loadTerminals()
    //   this.terminalsLoading = false
    // }, () => {
    //   return this.terminalsLoaded
    // })
    await Promise.all([this.loadUsersWorker.start()])
    setTimeout(() => {
      this.reset()
      this.$nextTick(() => {
        if (this.auto) {
          this.login()
        } else {
          if (!this.model.username) {
            this.$refs.username.focus()
          } else if (!this.model.password) {
            this.$refs.password.focus()
          } else {
            this.$refs.username.focus()
          }
        }
      })
    }, 200)
  },
  beforeDestroy () {
    this.loadUsersWorker && this.loadUsersWorker.cancel()
    // this.loadTerminalsWorker && this.loadTerminalsWorker.cancel()
  },
  methods: {
    ...mapAuthorizeMutations({
      storeLogin: 'login'
    }),
    ...mapDicActions(['loadUsers']),
    reset () {
      Object.assign(this.model, this.initialModel)
    },
    async login () {
      if (this.logining) return
      const valid = await this.$refs.form.validate()
      if (!valid) {
        return
      }
      this.logining = true
      const params = {
        ...this.model
      }
      const result = await this.$$api.bis.post('/authorize/login', params)
      // result.notifyIfFail()
      if (result.success) {
        const { userId, token } = result.data
        this.storeLogin({ userId, username: params.username, token })
        this.$emit('success')
        location.reload()
      } else {
        if (result.code === 400 && result.message === 'login.username_or_pass_wrong') {
          this.logining = false
          return this.$q.notify({ type: 'negative', message: '用户名或密码错误' })
        } else if (result.code === 400) {
          this.logining = false
          return this.$q.notify({ type: 'negative', message: '无权限访问！' })
        }
        result.notifyIfFail()
      }
      this.logining = false
    },
    async onFieldEnter (current, next) {
      const outcome = await current.validate()
      if (outcome) {
        if (typeof (next) === 'function') {
          next()
        } else {
          next.focus()
        }
      }
    }
  }
}
</script>

<style lang="scss">
.b-login {
  width: 400px;
  border-radius: 0.5em;
  // background-color: #1171bc10;
  background-color: white;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
  padding: 2em;
  &-actions {
    display: flex;
    justify-content: flex-end;
    padding: 40px 0 0 0;
    > * {
      margin-left: 20px;
    }
  }
}
</style>
